import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { verifyMarketingPassword } from '../../services/marketingAccessService';

const { FiLock, FiArrowRight } = FiIcons;

export default function PasswordGate({ onUnlock }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const ok = await verifyMarketingPassword(password);
      if (ok) {
        onUnlock();
      } else {
        setError('That password is not correct.');
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }
    setLoading(false);
  };

  return (
    <section className="flex min-h-screen items-center justify-center px-4 pb-24 pt-32">
      <motion.form
        onSubmit={handleSubmit}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md text-center"
      >
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-[#3fc0fa]/15">
          <SafeIcon icon={FiLock} className="h-7 w-7 text-[#0b1423]" />
        </span>
        <p className="mt-8 text-xs font-bold uppercase tracking-[0.2em] text-[#3fc0fa]">Team only</p>
        <h1 className="mt-3 text-4xl font-black tracking-tight">Marketing area</h1>
        <p className="mt-4 text-slate-500">Enter the password to open sales and marketing materials.</p>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          autoFocus
          className="mt-8 w-full rounded-full border border-slate-200 bg-white px-6 py-4 text-center outline-none transition-colors focus:border-[#3fc0fa]"
        />
        {error && <p className="mt-3 text-sm text-red-500">{error}</p>}
        <button
          type="submit"
          disabled={loading || !password}
          className="site-button mt-5 inline-flex w-full items-center justify-center gap-2 rounded-full px-6 py-4 font-bold disabled:opacity-50"
        >
          {loading ? 'Checking…' : 'Unlock'}
          <SafeIcon icon={FiArrowRight} />
        </button>
      </motion.form>
    </section>
  );
}